module.exports = __webpack_public_path__ + "static/media/video-thumbnail-3.65d4bb85.png";